import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getSizeList = createAsyncThunk(
  "get-size",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("size/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createSize = createAsyncThunk(
  "create-size",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("size", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editSize = createAsyncThunk(
  "edit-size",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`size/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateSize = createAsyncThunk(
  "update-size",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/size/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteSize = createAsyncThunk(
  "delete-size",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/size/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const sizeSlice = createSlice({
  name: "size",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSizeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSizeList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.sizeList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getSizeList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default sizeSlice.reducer;
